import tjCookie from '@/utils/tjCookie'
import { mpUtils } from '@tujia/fe-lib-bridge'
import { platformEnv } from '@/utils/platformConfig.js'
import { getChannelInfo } from '@common-libs/tj-channel'
import tokenManager from '@/business/tokenManager.js'

const channelId = getChannelInfo().channelId

export default {
  methods: {
    /**
     * 判断环境跳转登录
     * 业务参数不要加到参数中！！！错误示范：autoGetRedpacketId，通过拼接地址传入
     */
    async goLoginPage({ redirect } = {}) {
      const platform = await this.getEnv()
      console.log('login-->', platform);
      window.localStorage.setItem('isFromLoginPage', 1)
      const _clientHref = (redirect || window.location.href).replace('&tjuserid=0', '').replace('&tjusertoken=00000000-0000-0000-0000-000000000000', '')
      if (platformEnv.isMpEnv) {
        mpUtils.redirectTo({
          url: `/pages/tbnb/pages/common/webview/index?h5url=${encodeURIComponent(_clientHref)}&needLogin=true`
        })
      } else {
        if (platform === 2) { // 途家APP
          // 跳转客户端登录页
          if (window.tjBridge) {
            const appInit = require('@/utils/tj_app_init').default
            window.tjBridge.business.login({
              action: 2,
              success: (res) => {
                let { userId, userToken } = res
                appInit({
                  tjuserid: userId,
                  tjusertoken: userToken
                })
                window.location.replace(_clientHref)
              },
              fail: (res) => {
                // errorcode=10012,取消
                console.log(res)
              },
              final: () => {}
            })
          } else {
            window.location.href = `${process.env.VUE_APP_PASSPORT_TUJIA_HOST}/H5Site/LoginPage/?srcurl=${encodeURIComponent(_clientHref)}&srcLocalSite=goSite`
          }
        } else if (platform === 9) { // 携程APP
          // mustlogin 1｜强制登录  0｜非强制登录
          // 加时间戳是为了兼容微信安卓版本中点击不生效的问题
          const isFvt = location.href.includes('fvt')
          const ctripLoginUrl = `https://m.${isFvt ? 'fat2726.qa.nt.ctripcorp' : 'ctrip'}.com/webapp/newbnb/transform.html?targeturl=${encodeURIComponent(encodeURIComponent(_clientHref))}`
          location.replace(ctripLoginUrl)

          console.log('from ctrip', ctripLoginUrl);
        } else {
          // 移动端浏览器跳转登录页
          if (this.$root.isMobile) {
            if (channelId === 'ctrip') {
              const isFvt = location.href.includes('fvt')
              const ctripLoginUrl = `https://m.${isFvt ? 'fat2726.qa.nt.ctripcorp' : 'ctrip'}.com/webapp/newbnb/transform.html?targeturl=${encodeURIComponent(encodeURIComponent(_clientHref))}`
              location.replace(ctripLoginUrl)
            } else {
              window.location.href = `${process.env.VUE_APP_PASSPORT_TUJIA_HOST}/H5Site/LoginPage/?srcurl=${encodeURIComponent(_clientHref)}&srcLocalSite=goSite`
            }
          } else {
            window.location.href = `${process.env.VUE_APP_PASSPORT_TUJIA_HOST}/PortalSite/LoginPage/?srcLocalSite=goSite&returnUrl=${encodeURIComponent(_clientHref)}`
          }
        }
      }
    },
    async isLogin() {
      const userToken = await tokenManager.get()
      return (
        tjCookie.getUserId() !== '0' &&
        tjCookie.getUserId() !== 'undefined' &&
        typeof tjCookie.getUserId() !== 'undefined' &&
        typeof userToken !== 'undefined' &&
        userToken !== 'undefined' &&
        userToken !== '00000000-0000-0000-0000-000000000000'
      )
    }
  }
}
